import { EquipmentCard } from '@tractorzoom/components';
import React from 'react';
import { useMediaQueries } from '@src/hooks/useMediaQueries';
import useStyles from './styles';

const LoadingGrid = () => {
    const classes = useStyles();
    const { isSmallScreen, isLargeScreen } = useMediaQueries();

    let numSkeleton = 15;

    if (isLargeScreen) {
        numSkeleton = 8;
    }

    if (isSmallScreen) {
        numSkeleton = 4;
    }

    return (
        <div className={classes.grid}>
            {[...Array(numSkeleton)].map((_, i) => (
                <div data-testid='loading-skeleton' key={i}>
                    <EquipmentCard isLoading />
                </div>
            ))}
        </div>
    );
};

export default LoadingGrid;
